module.exports = __webpack_public_path__ + "img/misc-mailbox.ec90cd5.svg";